import styled from "styled-components";
export const RootContainer = styled.div`
	position: relative;
	margin: 0;
  background-color: #F2F1F0;
	/* padding: 20px 16px; */
	/* .ant-table-wrapper {
    margin: 82px 16px 24px 16px;
  } */
`;

export const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TitleWrapper = styled.div`
  width: fit-content;
	margin: 24px 0 24px 0;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 10px;
  border-radius: 22px;
  background: #DFDFDF;
  padding: 7px 24px;
`;

export const Title = styled.p`
  color: #817774;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const SubTitle = styled.p`
  color: #13100F;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px; /* 156.25% */
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
`;

export const FriendListContiner = styled.div`
  & > div:first-child {
    border-radius: 24px 24px 0 0;
  }

  & > div:last-child {
    border-radius: 0 0 24px 24px;
  }
`

export const OuterDiv = styled.div`
	display: flex;
	justify-content: space-between;
  align-items: center;
  gap: 16px;
	background-color: #FFF;
  margin: 0 0 1px 0;
`;

export const InfoText = styled.span`
	color: ${(props) => (props.isName !== true ? "#8E969F" : "#13100F")};
	font-size: 14px;
	line-height: 14px;
	font-weight: ${(props) => (props.isName === true ? "600" : "200")};
  text-align: left;
  margin-right: 16px;`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;
  gap: 4px;
`;

export const IndexNumber = styled.div`
	color: #f9f9f9;
	display: flex;
	gap: 7px;
  flex-grow: 1;
`;

export const Number = styled.div`
  width: 60px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #F2F1F0;
  color: #342309;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;




